import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

import AppSettings from 'src/app/common/app.settings';
import FieldsConstants from 'src/app/common/fields.constants';
import { SearchState } from 'src/app/interfaces/search.interface';

@Directive()
export class PaginationComponentShared {
  @Input({ required: true }) public searchState: SearchState;

  @Output() public pageChanged: EventEmitter<number> = new EventEmitter<number>();

  public mobileScreenWidth: number = AppSettings.PAGINATION_BOX_MOBILE_SCREEN_WIDTH;
  public innerWidth: number;
  public defaultCount: number = FieldsConstants.SEARCH_DEFAULT_RESULTS_COUNT;
  public count = 0;

  /**
   * @description Listens to the window width changes in order to update innerWidth prop.
   */
  @HostListener('window:resize')
  public onResize(): void {
    this.innerWidth = window.innerWidth;
  }

  /**
   * @description Called on page changes and emits pageChanged event the with passed page number.
   * @param { number } page
   */
  public onPageChanged(page: number): void {
    this.pageChanged.emit(page);
    window.scrollTo(0, 0);
  }
}
